import { filterable } from "./filterable.js"
import { initFilter } from "./count.js"
import { initSwiper } from "./swiper.js"
import { showMore } from "./show-more.js"
import GLightbox from 'glightbox'


document.addEventListener("DOMContentLoaded", () => {
  filterable('filterable', 'filterable-list')
  initFilter('filterable')
  initSwiper(".post-swiper")
  showMore(".city-description")
  GLightbox({
    selector: '.glightbox',
    touchNavigation: true,
    loop: true,
    zoomable: true,
    autoplayVideos: true,
    closeEffect: 'none',
    closeButton: true
  })
})

